import { Form, FormInstance, Input } from "antd";
import FileUploader from "../../common/FileUploader";

type Props = {
  form: FormInstance<any>;
};

export default function AboutOrganization({ form }: Props) {
  return (
    <div>
      <Form.Item
        name="name"
        label="Name"
        className="mb-4"
        rules={[
          {
            required: true,
            message: "Please enter name",
          },
        ]}
      >
        <Input size="large" placeholder="Name" />
      </Form.Item>
      <Form.Item
        name="About Organization"
        label="About Organization"
        className="mb-4"
        rules={[
          {
            required: true,
            message: "Please enter about organization",
          },
        ]}
      >
        <Input size="large" placeholder="About the organization" />
      </Form.Item>

      <Form.Item
        name="Profile Picture"
        label="Profile Picture"
        className="mb-1"
        valuePropName="fileUrl"
        //   rules={[
        //     {
        //       required: true,
        //       message: "Please upload photo",
        //     },
        //   ]}
      >
        <FileUploader
          form={form}
          accept=".png, .jpg, .jpeg, .gif"
          name="Profile Picture"
          onChange={(url) =>
            form.setFieldsValue({
              nid_image_front: url,
            })
          }
        />
      </Form.Item>
    </div>
  );
}
